export default "__VITE_ASSET__Dl2Uz1Ne__"